/** List of all the MFs
 * `cep-remotes.json` file is not longer used.
 */

const mfNamesProd = [
  'account_mf',
  'bid_mf',
  'bidregistration_mf',
  'cart_mf',
  'cep_returnsandclaims_mf',
  'checkout_mf',
  'cloudreports_mf',
  'cms_mf',
  'configurationmanager_mf',
  'credit_mf',
  'customize_report_mf',
  'dashboard_mf',
  'empty_mf',
  'financecalculator_mf',
  'insight_mf',
  'invoice_mf',
  'loyaltymanagement_mf',
  'ost_mf',
  'partneractivation_mf',
  'payment_mf',
  'product_mf',
  'productconfigurator_mf',
  'quotemgmt_mf',
  'renewals_mf',
  'resellermanagement_mf',
  'resellermarketplace_mf',
  'return_mf',
  'sandbox_mf',
  'subscriptions_mf',
  'support_x4c_mf',
  'voucher_mf',
  'vri_mf',
  'xi_appstore_mf',
  'xi_workato_mf',
  'xi_psaintegration_mf',
];

const mfNamesBeta = [...mfNamesProd, 'endcustomer_mf', 'unifiedchat_ai_x4c_mf'];

const mfNamesStg = [...mfNamesBeta, 'aimatrix_mf'];

const envMappings: Record<
  'default' | 'production' | 'productionbeta',
  string[]
> = {
  default: mfNamesStg,
  production: mfNamesProd,
  productionbeta: mfNamesBeta,
};

const envKey = (process.env.NODE_ENV ?? 'staging') as keyof typeof envMappings;
const mfNames = envMappings[envKey] || envMappings.default;

export { mfNames };
